import useAppConfig from 'canvas_states/config/useAppConfig';
import type Language from '../../../../../types/Language';
import type { SelectChangeEvent } from '@mui/material';
import useCurrentCurrency from 'canvas_states/currency/useCurrentCurrency';
import useUrlInfo from '../../../utils/urls/useUrlInfo';
import useCurrentLanguage from 'canvas_states/language/useCurrentLanguage';

export interface HeaderLanguageCurrencyMenuProps {
  hideCurrencySelector?: boolean;
  onLanguageChange?: (newLanguage: Language) => void;
  pid: string;
}

const useLanguageCurrencySelectorsProps = (pid: string, onLanguageChange?: (newLanguage: Language) => void) => {
  const {
    selectors: { getLanguages, getCurrencies },
  } = useAppConfig();
  const languages = getLanguages();
  const currencies = getCurrencies();
  const {
    actions: { changeLanguageAndTranslation },
    states: { currentLanguage },
  } = useCurrentLanguage();

  const { requestId, addChannelSource, overrideChannelSource } = useUrlInfo().states;

  const {
    states: { currentCurrency },
    actions: { setSelectedCurrency },
  } = useCurrentCurrency();

  const handleLanguageChange = (event: SelectChangeEvent) => {
    const newLanguage = languages.find((f) => f.code === event.target.value);
    if (newLanguage !== undefined) {
      changeLanguageAndTranslation(newLanguage, pid, requestId, addChannelSource ?? overrideChannelSource ?? undefined);
      onLanguageChange?.(newLanguage);
    }
  };
  const handleCurrencyChange = (event: SelectChangeEvent) => {
    const newCurrency = currencies.find((c) => c.code === event?.target.value);
    if (newCurrency !== undefined) {
      setSelectedCurrency(newCurrency);
    }
  };

  return {
    actions: {
      handleCurrencyChange,
      handleLanguageChange,
    },
    states: {
      currentCurrency,
      currentLanguage,
      languages,
      currencies,
    },
  };
};
export default useLanguageCurrencySelectorsProps;
